import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid2';
import 'leaflet/dist/leaflet.css';
import { Box, Typography, Stack } from '@mui/material';

import Heatmap from '../components/heatmap';
import TreemapSoilRain from '../components/treemap_soil_rain';
import Scatter from '../components/scatter';
import MapLvSoilRainMax from '../components/map_lv_soil_rain';
import MapLvSoilRainPrainMax from '../components/map_lv_soil_rain_prain';
import CommonCard from '../item/common_card';
import VerticalBar from '../components/vertical_bar'
import Proggress from '../item/progress'
import HeaderSub from '../item/header_sub'
// import { useDataPolling, useDataFromS3 } from '../func/get_data_swr';
import { useDataFromS3 } from '../hooks/useDataFromS3';

import {
    setSrRiskColor
} from '../func/color';
import {
    getAllByDateTimeWithSrAreaInfo, getMaxLvSrByCode, getMaxLvSrRainByCode,
    getAllByCode, joinData, getTimeAry, filterDataByCodeAry,
    getSrRankWithLimit, convertAreaDataSrFromMshData,
    convertAreaDataSrRainFromMshData, convertAreaDataRainGaugeFromMshData
    , convertAreaDataSrRankFromMshData, convertAreaDataSrRainRankFromMshData
} from '../func/util'
import { DATA_TYPE } from '../const/user_config'
import { GRID_NORMAL, GRID_RANK } from '../const/grid'
import { BASE_LAYER_LIST } from '../const/map_config'
import { SR_RISK_COLOR } from '../const/color'

import choropleth_area from '../data/area.json';
import choropleth_msh from '../data/msh.json';

const SoilRain = (props) => {

    const [selectLayer, setSelectLayer] = useState(
        BASE_LAYER_LIST.find(layer => layer.index.toString() === props.defaultUnit) || BASE_LAYER_LIST[1]
    );

    // 市町村、字、メッシュ、個別の選択をクリアするかしないかのフラグ
    const [shouldClearSelect, setShouldClearSelect] = useState(false)

    // 地図（市町村・字・メッシュ）
    const [citySoilRainLvJmaH1, setCitySoilRainLvJmaH1] = useState(null);
    const [areaSoilRainLvJmaH1, setAreaSoilRainLvJmaH1] = useState(null);
    const [mshSoilRainLvJmaH1, setMshSoilRainLvJmaH1] = useState(null);
    const [citySoilRainLvH1, setCitySoilRainLvH1] = useState(null);
    const [areaSoilRainLvH1, setAreaSoilRainLvH1] = useState(null);
    const [mshSoilRainLvH1, setMshSoilRainLvH1] = useState(null);
    // ランキング
    const [soilRainJmaAllRankData, setSoilRainJmaAllRankData] = useState(null);
    const [soilRainAllRankData, setSoilRainAllRankData] = useState(null);
    // ツリーマップ
    const [soilRainJmaTreeMapData, setSoilRainJmaTreeMapData] = useState(null);
    // 散布図
    const [soilRainScatterData, setSoilRainScatterData] = useState(null);
    // ヒートマップ
    const [soilRainAllLvDatetime, setSoilRainAllLvDatetime] = useState(null);

    const [dateArray, setDateArray] = useState(null);
    const [h6DateArray, setH6DateArray] = useState(null);
    const [shouldFetchMain, setShouldFetchMain] = useState(false);

    const prevDataARef = useRef(null);

    // // APIに含めるクエリパラメータの作成
    // const params = new URLSearchParams();
    // props.prefCode.forEach(code => params.append('pref_code', code));

    // 全データ再取得の要否を定期監視する
    const { data, isLoading, error } = useDataFromS3(`api/get_datetime_latest`);

    // サーバーの最終更新日時が変更されているか判定
    useEffect(() => {
        if (data && JSON.stringify(data) !== JSON.stringify(prevDataARef.current)) {
            prevDataARef.current = data;
            setShouldFetchMain(true); // dataが変わったらメインデータを取得
        } else {
            setShouldFetchMain(false); // dataが変わってないならメインデータを取得しない
        }
    }, [data]);

    let msh_sr_jma_url = null
    let msh_sr_url = null
    let msh_sr_rain_url = null
    let msh_rain_gauge_url = null
    if (shouldFetchMain) {
        msh_sr_jma_url = `api/get_msh_sr_jma`
        msh_sr_url = `api/get_msh_sr`
        msh_sr_rain_url = `api/get_msh_rain`
        msh_rain_gauge_url = `api/get_rain_mtr_risk`
    }

    // キキクル土壌雨量指数情報を取得
    const {
        data: mshSrJmaData,
        loading: mshSrJmaLoading,
        error: mshSrJmaError,
    } = useDataFromS3(msh_sr_jma_url);

    // PREIN土壌雨量指数情報を取得
    const {
        data: mshSrData,
        loading: mshSrLoading,
        error: mshSrError,
    } = useDataFromS3(msh_sr_url);

    // PREIN雨量情報を取得
    const {
        data: mshSrRainData,
        loading: mshSrRainLoading,
        error: mshSrRainError,
    } = useDataFromS3(msh_sr_rain_url);

    // PREIN雨量計情報を取得
    const {
        data: mshRainGaugeData,
        loading: mshRainGaugeLoading,
        error: mshRainGaugeError,
    } = useDataFromS3(msh_rain_gauge_url);

    // ランキングデータ取得
    const getRankData = (data, isOver, sliderValueRef, getLabelValue, getYValue) => {
        let rankData = data;
        if (isOver) {
            // 取得されたリスクの最大値を並べ替え（昇順/低い順）
            rankData.sort((a, b) => {
                if (a.sr_lv_max !== b.sr_lv_max) {
                    return a.sr_lv_max - b.sr_lv_max;
                }
                if (a.sr_val_max !== b.sr_val_max) {
                    return a.sr_val_max - b.sr_val_max;
                }
                return String(a.city_code).localeCompare(String(b.city_code));
            })
        } else {
            // 取得されたリスクの最大値を並べ替え（降順/高い順）
            rankData.sort((a, b) => {
                if (a.sr_lv_max !== b.sr_lv_max) {
                    return b.sr_lv_max - a.sr_lv_max;
                }
                if (a.sr_val_max !== b.sr_val_max) {
                    return b.sr_val_max - a.sr_val_max;
                }
                return String(a.city_code).localeCompare(String(b.city_code));
            })
        }

        // sliderValueに応じてリスクの最大値を並べ替え
        let series_ary = []
        let category_ary = []
        if (isOver) {
            for (let i = sliderValueRef.current[1]; i > sliderValueRef.current[0] - 1; i--) {
                if (rankData.length > i) {
                    series_ary.push({
                        x: '',
                        y: rankData[i].sr_val_max,
                        custom: {
                            city_name: rankData[i].city_name,
                            city_code: rankData[i].city_code,
                            area_lng: rankData[i].area_lng,
                            area_lat: rankData[i].area_lat,
                            sr_lv: rankData[i].sr_lv_max,
                            sr_val: rankData[i].sr_val_max
                        }
                    })
                    category_ary.push(rankData[i].city_name)
                }
            }
        } else {
            data.map(item => {
                series_ary.push({
                    x: '',
                    y: item.sr_val_max,
                    custom: {
                        city_name: item.city_name,
                        city_code: item.city_code,
                        area_lng: item.area_lng,
                        area_lat: item.area_lat,
                        sr_lv: item.sr_lv_max,
                        sr_val: item.sr_val_max
                    }
                })
                category_ary.push(item.city_name)
            })
        }
        return { rankData, series_ary, category_ary };
    }

    // ランキングクリック時の動作
    const verticalBarClickEvent = (clickedItem) => {
        props.setRiskMapCenter([clickedItem.custom.area_lng, clickedItem.custom.area_lat])
        setShouldClearSelect(false)
        setSelectLayer(BASE_LAYER_LIST.find(layer => layer.index.toString() === props.defaultUnit) || BASE_LAYER_LIST[1])
        props.setSelectArea([])
        props.setSelectSubCity([clickedItem.custom.city_code])
        props.setSelectMsh([]);
    }

    // ランキングのカラー（土砂）
    const getRankColor = (value, series, seriesIndex, dataPointIndex) => {
        return setSrRiskColor(series[seriesIndex].data[dataPointIndex]?.custom.sr_lv).color
    }

    const toZenkakuAll = (str) => {
        return str
            .replace(/[0-9A-Za-z]/g, s => String.fromCharCode(s.charCodeAt(0) + 0xFEE0)) // 半角英数字 → 全角
            .replace(/,/g, '、')         // 半角カンマ → 全角カンマ
            .replace(/ /g, '　')         // 半角スペース → 全角スペース
            .replace(/\(/g, '（')        // 半角( → 全角（
            .replace(/\)/g, '）');       // 半角) → 全角）
    };

    // ランキングのラベルフォーマット
    const getLabelFormat = (value) => {
        const str = toZenkakuAll(String(value));
        // 8文字以上は省略
        if (str.length >= 8) {
            return str = str.slice(0, 3) + '…' + str.slice(-4);
        }
        return '　'.repeat(8 - str.length) + str;
    }

    // ランキングのX軸ツールチップフォーマット
    const tooltipFormatX = (opts) => {
        return opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex].custom.city_name;
    }

    // ランキングのY軸ツールチップフォーマット
    const tooltipFormatY = (val) => {
        return String(val);
    }

    // ランキングのY軸ツールチップフォーマット
    const tooltipFormatCustom = (opts, areaNameAry, areaRiverNameAry) => {
        const label = opts.w.globals.labels[opts.dataPointIndex]; // y軸ラベル
        const value = opts.series[opts.seriesIndex][opts.dataPointIndex]; // 値
        const seriesName = opts.w.globals.seriesNames[opts.seriesIndex];

        return `<div style="padding: 4px 8px; font-size: 12px;">
                ${label} ${seriesName}: ${value}
                </div>`;
    }

    // 散布図データ取得
    const getSeries = (chartData, isSlider, value) => {
        let res = [];
        if (isSlider) {
            for (let i = value[1]; i > value[0]; i--) {
                if (chartData.length - 1 > i) {
                    const [y, x] = chartData[i].h1h24_val; // y: 1時間雨量, x: 24時間雨量
                    const obj = {
                        name: chartData[i].name,
                        data: [[x, y]],
                        cityCode: chartData[i].city_code,
                        arealng: chartData[i].area_lng,
                        arealat: chartData[i].area_lat
                    };
                    res.push(obj);
                }
            }
        } else {
            chartData.forEach(item => {
                const [y, x] = item.h1h24_val; // y: 1時間雨量, x: 24時間雨量
                const obj = {
                    name: item.name,
                    data: [[x, y]],
                    cityCode: item.city_code,
                    arealng: item.area_lng,
                    arealat: item.area_lat
                };
                res.push(obj);
            });
        }
        return res;
    }

    // 散布図のカラー
    const getColors = (chartData, isSlider, value, w) => {
        let res = []
        if (isSlider) {
            for (let i = value[1]; i > value[0]; i--) {
                if (chartData.length - 1 > i) {
                    res.push(setSrRiskColor(chartData[i].sr_level).color)
                }
            }
        } else {
            if (chartData.length > 0) {
                chartData.map(item => {
                    res.push(setSrRiskColor(item.sr_level).color)
                })
            }
        }
        return res;
    }

    // X軸のみの配列を取得
    const x_ary = (scatterData) => {
        return scatterData.map((obj) => obj.h1h24_val[1]);
    }

    // Y軸のみの配列を取得
    const y_ary = (scatterData) => {
        return scatterData.map((obj) => obj.h1h24_val[0]);
    }

    // 散布図クリック時の動作
    const scatterClickEvent = (series, seriesIndex) => {
        props.setRiskMapCenter([series[seriesIndex].arealng, series[seriesIndex].arealat])
        setShouldClearSelect(false)
        setSelectLayer(BASE_LAYER_LIST.find(layer => layer.index.toString() === props.defaultUnit) || BASE_LAYER_LIST[1])
        props.setSelectArea([])
        props.setSelectSubCity([series[seriesIndex].cityCode]);
        props.setSelectMsh([]);
    }

    // 散布図ツールチップ情報
    const tooltipInfo = (item) => {
        return item
    }

    const getHeatmapData = (date_ary, area_val_ary, isOver) => {
        let sorted_ary = []

        if (area_val_ary.length > 1) {
            if (isOver) {
                // 取得されたリスクの合計値の小さい順に並び替える（昇順/低い順）
                sorted_ary = [...area_val_ary].sort((a, b) => {
                    const lvMaxA = Math.max(...a.sr_lv.slice(6));
                    const lvMaxB = Math.max(...b.sr_lv.slice(6));
                    const valMaxA = Math.max(...a.sr_val.slice(6));
                    const valMaxB = Math.max(...b.sr_val.slice(6));
                    if (lvMaxA === lvMaxB) {
                        // sr_lv が同じなら city_code の昇順でソート
                        return valMaxA - valMaxB;
                    }
                    return lvMaxA - lvMaxB; // 昇順（小さい順）
                });
            } else {
                // 取得されたリスクの合計値の大きい順に並び替える（降順/高い順）
                sorted_ary = [...area_val_ary].sort((a, b) => {
                    const lvMaxA = Math.max(...a.sr_lv.slice(6));
                    const lvMaxB = Math.max(...b.sr_lv.slice(6));
                    const valMaxA = Math.max(...a.sr_val.slice(6));
                    const valMaxB = Math.max(...b.sr_val.slice(6));
                    if (lvMaxA === lvMaxB) {
                        // sr_lv が同じなら area_code の降順でソート
                        return valMaxB - valMaxA;
                    }
                    return lvMaxB - lvMaxB; // 降順（大きい順）
                });
            }
        } else {
            // 1件だけならそのまま渡す
            sorted_ary = area_val_ary
        }

        const chartData = sorted_ary.map((item) => ({
            name: item.city_name,
            data: item.sr_lv
                .map((val, i) => {
                const xVal = date_ary[i];
                if (xVal === null || xVal === undefined) return null; // スキップ
                return {
                    x: xVal,
                    y: val === 0 ? 0.0001 : val,
                    originalValue: val,
                    city_code: item.city_code,
                    area_lat: item.area_lat,
                    area_lng: item.area_lng,
                };
            })
            .filter(d => d !== null) // null のデータを除外
        }));
        return chartData;
    }

    // ヒートマップクリック時の動作
    const heetmapClickEvent = (clickedItem) => {
        const cityCode = clickedItem.city_code;
        props.setRiskMapCenter([clickedItem.area_lng, clickedItem.area_lat])
        setShouldClearSelect(false)
        setSelectLayer(BASE_LAYER_LIST.find(layer => layer.index.toString() === props.defaultUnit) || BASE_LAYER_LIST[1])
        props.setSelectArea([])
        props.setSelectSubCity([cityCode]);
        props.setSelectMsh([]);
    }

    // ヒートマップのカラー
    const colorScale = (dataType) => {
        return {
            ranges: [
                { from: 0, to: 1, name: 'レベル1', color: SR_RISK_COLOR.LEVEL_1.color },
                { from: 2, to: 2, name: 'レベル2', color: SR_RISK_COLOR.LEVEL_2.color },
                { from: 3, to: 3, name: 'レベル3', color: SR_RISK_COLOR.LEVEL_3.color },
                { from: 4, to: 4, name: 'レベル4', color: SR_RISK_COLOR.LEVEL_4.color },
                { from: 5, to: 10, name: 'レベル5', color: SR_RISK_COLOR.LEVEL_5.color },
            ]
        }
    }

    // データ整備用のパラメータを取得
    const getParams = (keyAry, keyName = '') => {

        const features_area = choropleth_area.features
        const features_msh = choropleth_msh.features

        // メッシュデータ取得
        const masterMshFeatures = features_msh.filter(f =>
            keyAry.includes(f.properties[keyName])
        );

        // メッシュデータの properties.area_code を配列で取得(これが対象の字コード)
        const area_code_ary = [...new Set(masterMshFeatures.map(feature => feature.properties.area_code))];
        // 字のマスターデータ取得
        const masterAreaFeatures = features_area.filter(f =>
            area_code_ary.includes(f.properties.id)
        );

        // メッシュデータの properties.id を配列で取得(これが対象のメッシュコード)
        const msh_code_ary = masterMshFeatures.map(feature => feature.properties.id);

        return {
            msh_code_ary, area_code_ary,
            masterMshFeatures, masterAreaFeatures
        };
    }
    // ローディング開始
    const startLoading = () => {
        props.setReady(prev => {
            const updated = Object.fromEntries(
                Object.keys(prev).map(key => [key, false])
            );
            return updated;
        });

    }

    const clickHandler = (center, code_ary) => {
        // ローディング開始
        startLoading()

        props.setRiskMapCenter(center)
        props.setSelectArea([])
        props.setSelectSubCity(code_ary);
        props.setSelectMsh([]);
    }

    useEffect(() => {
        // ローディング開始
        startLoading()
        const fetchData = async () => {
            let params_obj = {}
            let date_ary = []
            let h6_date_ary = {}

            let msh_sr_jma_all_datetime = []
            let city_sr_jma_lv_all_datetime = []
            let city_sr_jma_lv_max = []
            let area_sr_jma_lv_max = []
            let msh_sr_jma_lv_max = []
            let sr_jma_convert_datetime = []
            let sr_jma_lv_all_datetime = []
            let sr_jma_lv_rank = []
            let sr_jma_lv_treemap = []

            let msh_sr_all_datetime = []
            let city_sr_lv_all_datetime = []
            let city_sr_lv_max = []
            let area_sr_lv_max = []
            let msh_sr_lv_max = []
            let sr_convert_datetime = []
            let sr_lv_all_datetime = []
            let sr_lv_rank = []
            let sr_prein_flg = false

            let msh_rain_gauge_all_data = []
            let city_sr_scatter_all_datetime = []

            if (props.selectArea && Array.isArray(props.selectArea)
                && props.selectArea.length > 0) {
                params_obj = getParams(props.selectArea, 'area_code')
            } else if (props.selectMsh && Array.isArray(props.selectMsh)
                && props.selectMsh.length > 0) {
                params_obj = getParams(props.selectMsh, 'id')
            } else if (props.selectSubCity && Array.isArray(props.selectSubCity)
                && props.selectSubCity.length > 0) {
                params_obj = getParams(props.selectSubCity, 'city_code')
            } else {
                params_obj = getParams(props.selectCitys, 'city_code')
            }

            if (Object.keys(params_obj).length > 0) {
                // 日時の配列を取得
                date_ary = getTimeAry(data, false)
                h6_date_ary = getTimeAry(data, props.h6Switch)

                // メッシュコードごとの土壌雨量指数のオブジェクト配列を取得（キキクル）
                // [{ code: 503021111（メッシュコード）,
                // sr_lv: [1, 2, 3]
                // sr_val: [10, 20, 30]]
                msh_sr_jma_all_datetime = getAllByCode(params_obj.msh_code_ary, mshSrJmaData, false)
                // msh_sr_jma_all_datetime = getAllBySrDateTime(params_obj.msh_code_ary, mshSrJmaData)
                if (msh_sr_jma_all_datetime.length > 0) {
                    // キキクルかPREINか判断するフラグ
                    sr_prein_flg = false;
                    //// 字コードごとのリスクと雨量のオブジェクト配列を取得
                    // [{ code: 401010010（字コード）, 
                    // sr_lv: [1, 2, 3]
                    // sr_val: [10, 20, 30],}, ..............]
                    city_sr_jma_lv_all_datetime = convertAreaDataSrFromMshData(params_obj.masterMshFeatures, msh_sr_jma_all_datetime)
                    // 地図の字レイヤー用のデータ
                    area_sr_jma_lv_max = getMaxLvSrByCode(city_sr_jma_lv_all_datetime, 0)
                    // 地図の市町村レイヤー用のデータ
                    city_sr_jma_lv_max = getMaxLvSrByCode(city_sr_jma_lv_all_datetime, 5)
                    // 地図のメッシュレイヤー用のデータ
                    msh_sr_jma_lv_max = getMaxLvSrByCode(msh_sr_jma_all_datetime, 0)
                    // 市町村コードごとのレベルと雨量のオブジェクト配列を取得
                    sr_jma_convert_datetime = convertAreaDataSrRankFromMshData(params_obj.masterMshFeatures, msh_sr_jma_all_datetime)
                    // 土壌雨量指数（キキクル）のランキング用のデータ
                    sr_jma_lv_all_datetime = getAllByDateTimeWithSrAreaInfo(params_obj.masterMshFeatures, sr_jma_convert_datetime)
                    sr_jma_lv_rank = getSrRankWithLimit(sr_jma_lv_all_datetime, 200, sr_prein_flg)

                    // 土壌雨量指数（キキクル）のツリーマップ用のデータ
                    sr_jma_lv_treemap = sr_jma_lv_rank.slice(0, 20);
                }

                // メッシュコードごとの土壌雨量指数のオブジェクト配列を取得（PREIN）
                // [{ code: 503021111（メッシュコード）, 
                // sr_lv: [1, 2, 3, 4, 5, 1, 2, 3, 4, 5]
                // sr_val: [10, 20, 30, 40, 50, 60, 70, 80, 90],}, ..............]
                // h1_val: [1, 2, 3, 4, 5, 1, 2, 3, 4, 5]
                // h24_val: [1, 2, 3, 4, 5, 1, 2, 3, 4, 5] 
                const msh_sr = getAllByCode(params_obj.msh_code_ary, mshSrData, props.h6Switch)
                const msh_sr_rain = getAllByCode(params_obj.msh_code_ary, mshSrRainData, props.h6Switch)
                msh_sr_all_datetime = joinData(msh_sr, msh_sr_rain)
                if (msh_sr_all_datetime.length > 0) {
                    // キキクルかPREINか判断するフラグ
                    sr_prein_flg = true;
                    //// 字コードごとのレベルと雨量のオブジェクト配列を取得
                    // [{ code: 401010010（字コード）, 
                    // sr_lv: [1, 2, 3, 4, 5, 1, 2, 3, 4, 5], 
                    // sr_val: [10, 20, 30, 40, 50, 60, 70, 80, 90],}, ..............]
                    // h1_val: [1, 2, 3, 4, 5, 1, 2, 3, 4, 5]
                    // h24_val: [1, 2, 3, 4, 5, 1, 2, 3, 4, 5]
                    city_sr_lv_all_datetime = convertAreaDataSrRainFromMshData(params_obj.masterMshFeatures, msh_sr_all_datetime)

                    // 地図の字レイヤー用のデータ
                    area_sr_lv_max = getMaxLvSrRainByCode(city_sr_lv_all_datetime, 0)
                    // 地図の市町村レイヤー用のデータ
                    city_sr_lv_max = getMaxLvSrRainByCode(city_sr_lv_all_datetime, 5)
                    // 地図のメッシュレイヤー用のデータ
                    msh_sr_lv_max = getMaxLvSrRainByCode(msh_sr_all_datetime, 0)
                    // 市町村コードごとのレベルと雨量のオブジェクト配列を取得
                    sr_convert_datetime = convertAreaDataSrRainRankFromMshData(params_obj.masterMshFeatures, msh_sr_all_datetime)
                    // 土壌雨量指数（PREIN）のヒートマップ
                    sr_lv_all_datetime = getAllByDateTimeWithSrAreaInfo(params_obj.masterMshFeatures, sr_convert_datetime)
                    // 土壌雨量指数（PREIN）のランキング用のデータ
                    sr_lv_rank = getSrRankWithLimit(sr_lv_all_datetime, 200, sr_prein_flg)
                }

                // メッシュコードごとの土壌雨量指数のオブジェクト配列を取得（PREIN）
                // [{ code: 503021111（メッシュコード）,
                // sr_lv: [1, 2, 3, 4, 5, 1, 2, 3, 4, 5]
                // sr_val: [10, 20, 30, 40, 50, 60, 70, 80, 90],}, ..............]
                // h1_val: [1, 2, 3, 4, 5, 1, 2, 3, 4, 5]
                // h24_val: [1, 2, 3, 4, 5, 1, 2, 3, 4, 5]
                msh_rain_gauge_all_data = filterDataByCodeAry(params_obj.msh_code_ary, mshRainGaugeData)
                if (msh_rain_gauge_all_data.length > 0) {
                    city_sr_scatter_all_datetime = convertAreaDataRainGaugeFromMshData(params_obj.masterMshFeatures, msh_rain_gauge_all_data)
                }
            }

            // レイヤ（キキクル）
            setCitySoilRainLvJmaH1(city_sr_jma_lv_max.length > 0 ? city_sr_jma_lv_max : null)
            setAreaSoilRainLvJmaH1(area_sr_jma_lv_max.length > 0 ? area_sr_jma_lv_max : null)
            setMshSoilRainLvJmaH1(msh_sr_jma_lv_max.length > 0 ? msh_sr_jma_lv_max : null)

            // レイヤ（PREIN）
            setCitySoilRainLvH1(city_sr_lv_max.length > 0 ? city_sr_lv_max : null)
            setAreaSoilRainLvH1(area_sr_lv_max.length > 0 ? area_sr_lv_max : null)
            setMshSoilRainLvH1(msh_sr_lv_max.length > 0 ? msh_sr_lv_max : null)

            // ランキング（キキクル）
            setSoilRainJmaAllRankData(sr_jma_lv_rank.length > 0 ? sr_jma_lv_rank : null)
            // ランキング（PREIN）
            setSoilRainAllRankData(sr_lv_rank.length > 0 ? sr_lv_rank : null)

            // ツリーマップ（キキクル）
            setSoilRainJmaTreeMapData(sr_jma_lv_treemap.length > 0 ? sr_jma_lv_treemap : null)

            // 散布図
            setSoilRainScatterData(city_sr_scatter_all_datetime.length > 0 ? city_sr_scatter_all_datetime : null)

            // ヒートマップ（PREIN）
            setSoilRainAllLvDatetime(sr_lv_all_datetime.length > 0 ? sr_lv_all_datetime : null)

            // 日時
            setDateArray(date_ary.length > 0 ? date_ary : null)
            setH6DateArray(h6_date_ary.length > 0 ? h6_date_ary : null)
        };
        if (data
            && mshSrJmaData
            && mshSrData
            && mshSrRainData
            && mshRainGaugeData) {
            fetchData();
        }
    }, [data,
        mshSrJmaData,
        mshSrData,
        mshSrRainData,
        mshRainGaugeData,
        props.selectCitys, props.selectSubCity,
        props.selectArea, props.selectMsh, props.h6Switch
    ]);

    if (isLoading || data === undefined
        || (error && error.message.includes("Received HTML"))
        || mshSrJmaLoading || mshSrJmaData === undefined
        || (mshSrJmaError && mshSrJmaError.message.includes("Received HTML"))
        || mshSrLoading || mshSrData === undefined
        || (mshSrError && mshSrError.message.includes("Received HTML"))
        || mshSrRainLoading || mshSrRainData === undefined
        || (mshSrRainError && mshSrRainError.message.includes("Received HTML"))
        || mshRainGaugeLoading || mshRainGaugeData === undefined
        || (mshRainGaugeError && mshRainGaugeError.message.includes("Received HTML"))
    ) {
        // Loading表示
        return <Proggress />
    }

    if (error
        || mshSrJmaError
        || mshSrError
        || mshSrRainError
        || mshRainGaugeError
    ) {
        return (
            <>
                <Typography
                    sx={{
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        color: 'white',
                    }}
                >
                    申し訳ございません、データ取得に失敗しました。
                </Typography>
                <Typography
                    sx={{
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        color: 'white',
                    }}
                >
                    恐れ入りますが、しばらく時間をおいてから再度お試しください。
                </Typography>
            </>
        )
    }

    return (
        <>
            <Box
                sx={{
                    height: { xs: '100%', sm: 'calc(100dvh - 61px)' }, // 親が高さを持つ
                    boxSizing: 'border-box',
                }}
            >
                <HeaderSub
                    pageTitle={""}
                    dateTime={data[6]}
                />

                <Grid container
                    spacing={0}
                    columns={8}
                    // pt={1} pr={1}
                    // height={'100%'}
                    sx={{ height: '100%', width: '100%', padding: 0, m: 0 }} // Grid全体の高さ100%
                >
                    <Grid size={{ xs: 8, sm: 8, md: 3 }}>
                        <Stack spacing={0}
                            sx={{
                                border: '1px solid rgb(235, 227, 205)',
                                paddingBottom: '8px',
                            }}
                        >
                            <CommonCard
                                child={
                                    <MapLvSoilRainMax
                                        selectSubCity={props.selectSubCity}
                                        setSelectSubCity={props.setSelectSubCity}
                                        selectArea={props.selectArea}
                                        setSelectArea={props.setSelectArea}
                                        selectMsh={props.selectMsh}
                                        setSelectMsh={props.setSelectMsh}
                                        selectCitys={props.selectCitys}
                                        citySoilRainLvH1={citySoilRainLvJmaH1}
                                        areaSoilRainLvH1={areaSoilRainLvJmaH1}
                                        mshSoilRainLvH1={mshSoilRainLvJmaH1}
                                        riskMapZoom={props.riskMapZoom}
                                        riskMapCenter={props.riskMapCenter}
                                        selectLayer={selectLayer}
                                        setSelectLayer={setSelectLayer}
                                        shouldClearSelect={shouldClearSelect}
                                        setShouldClearSelect={setShouldClearSelect}
                                    />
                                }
                                title={"土砂キキクル情報（２時間先までの予測）"}
                                xsHeight="300px"
                                height='calc(50dvh - (36px * 0.5) - (17px * 0.5) - (8px * 0.5) - (8px * 0.5) - 31px)'
                            />
                            <Grid container spacing={0}>
                                <Grid size={{ xs: 12, sm: 12, md: 5 }}>
                                    <CommonCard
                                        child={
                                            <VerticalBar
                                                distance={18}
                                                limitVal={500}
                                                grid={GRID_RANK}
                                                allRankData={soilRainJmaAllRankData}
                                                dateArray={dateArray}
                                                getRankData={getRankData}
                                                plusValue={10}
                                                verticalBarClickEvent={verticalBarClickEvent}
                                                getRankColor={getRankColor}
                                                fontSize={'8px'}
                                                // getFormat={getFormat}
                                                maxWidth={160}
                                                getLabelFormat={getLabelFormat}
                                                enabled={true}
                                                tooltipFormatX={tooltipFormatX}
                                                tooltipFormatY={tooltipFormatY}
                                                tooltipFormatCustom={tooltipFormatCustom}
                                                height={'100%'}
                                                // setColor={setSrRiskColor}
                                                isReadyKey={['rank_soil_rain']}
                                                isReadyFlg={props.isReady.rank_soil_rain}
                                                setReady={props.setReady}
                                            />
                                        }
                                        title={"市町村ごとの土壌雨量指数ランキング"}
                                        xsHeight="200px"
                                        // height='96%'
                                        // height='calc(50dvh - 18px - 17px - 8px - 31px)'
                                        // タイトルが折り返してしまうことを考慮して「31px」を２倍引いている
                                        height='calc(50dvh - (36px * 0.5) - (17px * 0.5) - (8px * 0.5) - (8px * 0.5) - 31px - 25px)'
                                    />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 12, md: 7 }}>
                                    <CommonCard
                                        child={
                                            <TreemapSoilRain
                                                treemapData={soilRainJmaTreeMapData}
                                                dateArray={dateArray}
                                                clickHandler={clickHandler}
                                                setColor={setSrRiskColor}
                                                isReadyKey={['treemap_soil_rain']}
                                                isReadyFlg={props.isReady.treemap_soil_rain}
                                                setReady={props.setReady}
                                            />
                                        }
                                        title={"市町村ごとの警戒レベル"}
                                        xsHeight="200px"
                                        height='calc(50dvh - (36px * 0.5) - (17px * 0.5) - (8px * 0.5) - (8px * 0.5) - 31px - 15px)'
                                    />
                                </Grid>
                            </Grid>
                        </Stack>
                    </Grid>
                    <Grid size={{ xs: 8, sm: 8, md: 5 }}>
                        <Stack spacing={0}>
                            <Grid container spacing={0}>
                                <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                                    <CommonCard
                                        child={
                                            <MapLvSoilRainPrainMax
                                                selectSubCity={props.selectSubCity}
                                                setSelectSubCity={props.setSelectSubCity}
                                                selectArea={props.selectArea}
                                                setSelectArea={props.setSelectArea}
                                                selectMsh={props.selectMsh}
                                                setSelectMsh={props.setSelectMsh}
                                                selectCitys={props.selectCitys}
                                                citySoilRainLvH1={citySoilRainLvH1}
                                                areaSoilRainLvH1={areaSoilRainLvH1}
                                                mshSoilRainLvH1={mshSoilRainLvH1}
                                                riskMapZoom={props.riskMapZoom}
                                                riskMapCenter={props.riskMapCenter}
                                                selectLayer={selectLayer}
                                                setSelectLayer={setSelectLayer}
                                                shouldClearSelect={shouldClearSelect}
                                                setShouldClearSelect={setShouldClearSelect}
                                            />
                                        }
                                        title={"PREIN土壌雨量指数レベル（１５時間先までの予測）"}
                                        xsHeight="300px"
                                        // 「18px」ヘッダーの半分、「9px」時刻表示の半分、
                                        // 「8px」ページ全体のパディング分、「31px」タイトル分
                                        // height='calc(50dvh - 18px - 17px - 8px - 31px)'
                                        height='calc(50dvh - (36px * 0.5) - (17px * 0.5) - (8px * 0.5) - (8px * 0.5) - 31px)'
                                    />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                                    <CommonCard
                                        child={
                                            <>
                                                <Scatter
                                                    distance={100}
                                                    scatterData={soilRainScatterData}
                                                    getSeries={getSeries}
                                                    getColors={getColors}
                                                    x_ary={x_ary}
                                                    y_ary={y_ary}
                                                    maxValX={250}
                                                    maxValY={70}
                                                    scatterClickEvent={scatterClickEvent}
                                                    tooltipInfo={tooltipInfo}
                                                    label={"土壌雨量指数レベル"}
                                                    textX={"直近24時間雨量"}
                                                    textY={"1時間雨量"}
                                                    whiteSpace={'normal'}
                                                    tooltipContent={(tooltipInfo, label) => (
                                                        <>
                                                            <Box sx={{ fontSize: 14 }}>雨量計名: <Box component="span" sx={{ fontWeight: 'bold' }}>{tooltipInfo?.data?.name}</Box></Box>
                                                            <Box sx={{ margin: '8px 0' }} />
                                                            <Box>場所: <Box component="span" sx={{ fontWeight: 'bold' }}>{tooltipInfo?.data?.address}</Box></Box>
                                                            <Box>{label}: <Box component="span" sx={{ fontWeight: 'bold' }}>{tooltipInfo?.data?.sr_level}</Box></Box>
                                                            <Box>土壌雨量指数: <Box component="span" sx={{ fontWeight: 'bold' }}>{tooltipInfo?.data?.sr_val}</Box></Box>
                                                            <Box>1時間雨量: <Box component="span" sx={{ fontWeight: 'bold' }}>{tooltipInfo?.data?.h1h24_val?.[0]}</Box></Box>
                                                            <Box>24時間雨量: <Box component="span" sx={{ fontWeight: 'bold' }}>{tooltipInfo?.data?.h1h24_val?.[1]}</Box></Box>
                                                            <Box>日時: <Box component="span" sx={{ fontWeight: 'bold' }}>{tooltipInfo?.data?.date}</Box></Box>
                                                        </>
                                                    )}
                                                    isReadyKey={['scatter_plot_soil_rain']}
                                                    isReadyFlg={props.isReady.scatter_plot_soil_rain}
                                                    setReady={props.setReady}
                                                />
                                            </>
                                        }
                                        title={"福岡県災害対策本部設置基準"}
                                        xsHeight="200px"
                                        height='calc(50dvh - (36px * 0.5) - (17px * 0.5) - (8px * 0.5) - (8px * 0.5) - 31px)'
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={0}>
                                <Grid size={{ xs: 12, sm: 12, md: 4 }}>
                                    <CommonCard
                                        child={
                                            <VerticalBar
                                                distance={18}
                                                limitVal={500}
                                                grid={GRID_RANK}
                                                allRankData={soilRainAllRankData}
                                                dateArray={h6DateArray}
                                                getRankData={getRankData}
                                                plusValue={10}
                                                verticalBarClickEvent={verticalBarClickEvent}
                                                getRankColor={getRankColor}
                                                fontSize={'8px'}
                                                maxWidth={160}
                                                getLabelFormat={getLabelFormat}
                                                enabled={true}
                                                tooltipFormatX={tooltipFormatX}
                                                tooltipFormatY={tooltipFormatY}
                                                tooltipFormatCustom={tooltipFormatCustom}
                                                height={'100%'}
                                                isReadyKey={['rank_soil_rain_prein']}
                                                isReadyFlg={props.isReady.rank_soil_rain_prein}
                                                setReady={props.setReady}
                                            />
                                        }
                                        title={"市町村ごとの土壌雨量指数ランキング"}
                                        xsHeight="200px"
                                        height='calc(50dvh - (36px * 0.5) - (17px * 0.5) - (8px * 0.5) - (8px * 0.5) - 31px)'
                                    />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 12, md: 8 }}>
                                    <CommonCard
                                        child={
                                            <Heatmap
                                                distance={18}
                                                limitDataCount={200}
                                                dataType={DATA_TYPE.SOIL_RAIN}
                                                defaultUnit={props.defaultUnit}
                                                dateArray={h6DateArray}
                                                allRiskDatetime={soilRainAllLvDatetime}
                                                getHeatmapData={getHeatmapData}
                                                heetmapClickEvent={heetmapClickEvent}
                                                colorScale={colorScale}
                                                isReadyKey={['heatmap_soil_rain']}
                                                isReadyFlg={props.isReady.heatmap_soil_rain}
                                                setReady={props.setReady}
                                            />}
                                        title={"日時、市町村ごとの土壌雨量指数レベル"}
                                        xsHeight="200px"
                                        height='calc(50dvh - (36px * 0.5) - (17px * 0.5) - (8px * 0.5) - (8px * 0.5) - 31px)'
                                    />
                                </Grid>
                            </Grid>
                        </Stack>
                    </Grid>
                </Grid>
            </Box>
        </>
    )
}
export default SoilRain;